import {FC, useEffect} from 'react'
import {KTIcon} from '../../../../_metronic/helpers'

type Props = {
  show: boolean
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  confirmVariant?: 'danger' | 'primary' | 'warning'
  onConfirm: () => void
  onCancel: () => void
  loading?: boolean
}

const ConfirmationModal: FC<Props> = ({
  show,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'danger',
  onConfirm,
  onCancel,
  loading = false,
}) => {
  useEffect(() => {
    if (show) {
      document.body.classList.add('modal-open')
    } else {
      document.body.classList.remove('modal-open')
    }
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [show])

  if (!show) return null

  const getButtonClass = () => {
    switch (confirmVariant) {
      case 'danger':
        return 'btn-danger'
      case 'warning':
        return 'btn-warning'
      case 'primary':
      default:
        return 'btn-primary'
    }
  }

  return (
    <>
      <div
        className='modal fade show d-block'
        tabIndex={-1}
        role='dialog'
        aria-modal='true'
        style={{backgroundColor: 'rgba(0,0,0,0.5)'}}
      >
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>{title}</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                onClick={onCancel}
                style={{cursor: 'pointer'}}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
            </div>
            <div className='modal-body'>
              <div className='text-gray-700' style={{whiteSpace: 'pre-line'}}>
                {message}
              </div>
            </div>
            <div className='modal-footer'>
              <button type='button' className='btn btn-light' onClick={onCancel} disabled={loading}>
                {cancelText}
              </button>
              <button
                type='button'
                className={`btn ${getButtonClass()}`}
                onClick={onConfirm}
                disabled={loading}
              >
                {loading && (
                  <span className='spinner-border spinner-border-sm me-2' role='status' />
                )}
                {confirmText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {ConfirmationModal}
